// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__B6aCW","table":"Table_table__YUzYe","th":"Table_th__XnQjq","tr":"Table_tr__+Wv3U","td":"Table_td__pf-Q9"};